import * as tslib_1 from "tslib";
import Compose from './Compose';
import Dock from './Dock';
import { observer } from 'mobx-react';
import { createInitialActions, executeInitialActions } from 'owa-initial-actions';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import * as React from 'react';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./composeCommon.scss');
var classNames = require('classnames/bind').bind(styles);
var FullCompose = /** @class */ (function (_super) {
    tslib_1.__extends(FullCompose, _super);
    function FullCompose(props) {
        var _this = _super.call(this, props) || this;
        _this.initialActions = createInitialActions();
        return _this;
    }
    FullCompose.prototype.componentDidMount = function () {
        executeInitialActions(this.initialActions);
    };
    FullCompose.prototype.render = function () {
        var viewState = this.props.viewState;
        var scrollContainerClasses = classNames(styles.scrollContainer, 'customScrollBar', {
            cardUI: isReadingPaneCardUIEnabled(),
            sticky: viewState.docking.useStickyDocking,
        });
        var composePlugins = findComposePlugins(viewState);
        var scrollAdapter = composePlugins.dockingPlugin.getScrollAdapter();
        return (React.createElement("div", null,
            React.createElement(Compose, { viewState: viewState, className: scrollContainerClasses, initialActions: this.initialActions, ref: function (ref) { return scrollAdapter.setScrollContainer(ref ? ref.getRootDiv() : null); } },
                React.createElement("div", { className: styles.scrollRegionBottomBuffer })),
            this.renderSubjectPickerConversationLoadingIndicator(),
            React.createElement(Dock, { viewState: viewState, initialActions: this.initialActions })));
    };
    FullCompose.prototype.renderSubjectPickerConversationLoadingIndicator = function () {
        if (isSubjectPickerSupported() &&
            this.props.viewState.subjectPickerViewState.isLoadingConversation) {
            return (React.createElement("div", { className: styles.conversationLoadingOverlay },
                React.createElement(Spinner, { className: styles.conversationLoadingSpinner })));
        }
        return null;
    };
    FullCompose = tslib_1.__decorate([
        observer
    ], FullCompose);
    return FullCompose;
}(React.Component));
export default FullCompose;
//# sourceMappingURL=FullCompose.js.map